import { register } from '@forter/core';
import { FcFormField } from './FcFormField.js';

register(FcFormField);
